import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta'
import Home from './views/Home.vue';

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: process.env.NODE_ENV === 'development' ? 'history' : 'hash', // TODO: Remove for production
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        mainClasses: ['main-bg is-left-sidebar is-left-sidebar--home'],
        headerClasses: ['is-left-sidebar--home'],
      },
    },
    {
      path: '/configurator',
      name: 'configurator',
      meta: {
        mainClasses: ['is-bottom-step-nav'],
      },
      props: route => ({ type: route.query.type, editId: route.query.id}),
      component: () => import('@/views/Configurator.vue'),
    },
    {
      path: '/not-found',
      name: 'error.notFound',
      component: () => import('@/views/Error404.vue'),
      meta: {
        mainClasses: ['is-left-sidebar is-left-sidebar--home'],
        headerClasses: ['is-left-sidebar--home'],
      },
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: () => import('@/views/Thanks.vue'),
      meta: {
        mainClasses: ['is-left-sidebar is-left-sidebar--home vertical-center'],
        headerClasses: ['is-left-sidebar--home'],
      },
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/Contact.vue'),
      meta: {
        mainClasses: ['is-left-sidebar is-left-sidebar--home'],
        headerClasses: ['is-left-sidebar--home'],
      }
    },
    {
      path: '/:slug',
      name: 'static',
      props: route => ({ slug: route.params.slug }),
      component: () => import('@/views/Static.vue'),
      meta: {
        mainClasses: ['is-left-sidebar is-left-sidebar--home'],
        headerClasses: ['is-left-sidebar--home'],
      },
    },
  ],
});



